import { Schema } from 'effect';

/**
 * Brand filter state schemas
 *
 * This module defines the internal state representation for brand filtering.
 * Brands are identified by UUIDs and stored in a HashSet for efficient lookup.
 *
 * @module BrandFilterState
 */

/**
 * Branded type for Brand UUID strings.
 * Ensures type safety by distinguishing brand UUIDs from regular strings.
 *
 * @example
 * const brandId = BrandUuid.make('01997f7d-71d0-735e-907c-95ea6b4337ef');
 */
export const BrandUuid = Schema.String.pipe(Schema.brand('BrandUuid'));

export type BrandUuid = Schema.Schema.Type<typeof BrandUuid>;

/**
 * HashSet of selected brand UUIDs.
 * Represents the current filter state for brands.
 *
 * @example
 * const selectedBrands = HashSet.make(
 *   BrandUuid.make('01997f7d-71d0-735e-907c-95ea6b4337ef'),
 *   BrandUuid.make('01997f7d-6f71-7283-9ca2-2834fee14266')
 * );
 */
export const BrandFilterStateSet = Schema.HashSet(BrandUuid);

export type BrandFilterStateSet = Schema.Schema.Type<typeof BrandFilterStateSet>;
